// import axios from 'axios';

// const api = axios.create({ baseURL: 'http://localhost:8082/api' });

// api.interceptors.request.use(cfg => {
//   const token = localStorage.getItem('token');
//   if (token) cfg.headers.Authorization = `Bearer ${token}`;
//   return cfg;
// });

// api.interceptors.response.use(
//   r => r,
//   err => {
//     const status = err.response?.status;
//     const url    = err.config?.url || '';
//     // Only force-logout on 401 (token expired/invalid).
//     // 403 on dashboard endpoints means backend not restarted yet — don't wipe the session.
//     if (status === 401) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//     }
//     return Promise.reject(err);
//   }
// );

// export default api;

import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API}/api`,
});

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    const status = err.response?.status;
    const hasToken = !!localStorage.getItem('token');
    // 401 = token expired/invalid -> always force logout.
    // 403 with no token present = genuinely unauthenticated (e.g. token was
    // cleared) -> also force logout, since this is a real "not logged in" case.
    // 403 WITH a token present is left alone -- that's a real permission
    // issue (or backend not restarted yet), not a logout case.
    if (status === 401 || (status === 403 && !hasToken)) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;